
import TrakkenSelect from '~/components/ui/TrakkenSelect.vue'
import TrakkenSubmit from '~/components/ui/TrakkenSubmit.vue'
import Translations from '~/mixins/translations.js'
import PreHead from '~/components/ui/PreHead.vue'
export default {
  mixins: [Translations],
  data() {
    return {
      response: {
        status: null,
        message: ''
      },
      files: '',
      formular: {
        location: null
      },
      acceptedPrivacyNotification: false,
      licenseNeeded: false,
      serviceConsulting: false,
      getFromChoosed: false,
      getFromChoosedError: false,
      selectControl: [],
      //privacyText:
      //'I agree that TRKKN may store my contact details for the purpose of the contact request and its follow-up.',
      privacyText:
        'By submitting this form, you agree to the use of reCAPTCHA, as well as the cookies and data it collects. reCAPTCHA helps us prevent spam. If you prefer not to use reCAPTCHA, you may email ',
      privacyText2:
        ' Any information you provide through this form or other means will be processed in accordance with our',
      privacyLinkLinkCachedURL: 'data-privacy-policy/',
      privacyLinkName: 'See Privacy Policy',
      privacyError: null,
      privacyErrorText: 'Please accept this.',
      interestError: null,
      interestErrorText: 'Please choose at least one',
      sortedLocations: [],
      recaptchaShow: false
    }
  },
  methods: {
    addSelectControl(idx) {
      if (!this.selectControl[idx]) {
        this.selectControl[idx] = {
          getFromChoosed: false,
          getFromChoosedError: false
        }
      }
    },
    getSelectOptions(allOptions) {
      const clearOptionsArray = []
      allOptions.forEach((element) => {
        clearOptionsArray.push(element.text)
      })
      return clearOptionsArray
    },
    alphabeticSort(locations) {
      const arr = []
      const sortedLocationsArray = locations.sort((a, b) =>
        a.location_name[0].text.localeCompare(b.location_name[0].text)
      )
      sortedLocationsArray.forEach((element) => {
        arr.push(element.location_name[0].text)
      })
      this.sortedLocations = arr
    },
    setGetFromChoosed(option, idx) {
      this.selectControl[idx].getFromChoosed = option
      this.selectControl[idx].getFromChoosedError = false
    },
    setFileClass(type) {
      switch (type) {
        case 'file':
          return 'custom-file-upload'
        case 'select':
          return 'custom-select-group'
        default:
          return ''
      }
    },
    validateItem(itemKey) {
      let valid = true
      if (this.formular[itemKey].validation) {
        this.formular[itemKey].validation.forEach((val) => {
          switch (val) {
            case 'isMulticheckbox':
              valid = this.licenseNeeded || this.serviceConsulting
              break
            case 'email':
              valid = !this.isEmail(itemKey) ? false : valid
              break
            case 'required':
              valid = !this.notEmpty(itemKey) ? false : valid
              break
          }
        })
      }
      return valid
    },
    validatePrivacy() {
      let isValid = this.acceptedPrivacyNotification
      this.privacyError = !isValid
      //
      //this.privacyError = true
      //
      return isValid
    },
    isEmail(key) {
      let str = this.formular[key].model
      let valid = /^[\w\-.+]+@[a-zA-Z0-9.-]+.[a-zA-z0-9]{2,4}$/.test(str)
      if (valid) {
        this.formular[key].errors.required = false
      } else {
        this.formular[key].errors.required =
          this.formular[key].input_validation_empty
      }
      return valid
    },
    notEmpty(key) {
      let str = this.formular[key].model
      var valid = str && str.length > 0
      if (valid) {
        this.formular[key].errors.required = false
      } else {
        this.formular[key].errors.required =
          this.formular[key].input_validation_empty
      }
      return valid
    },
    getFirstColClass() {
      //return this.isTwoCol ? 'col-12 col-md-5' : 'col-12'
      return 'col-12 col-lg-5 col-md-6 offset-md-0 offset-lg-0 pl-lg-0 prt-20'
    },
    getSecondColClass() {
      //return this.isTwoCol ? 'col-12 col-md-6 offset-md-1' : 'col-12'
      return 'col-12 col-lg-5 col-md-6 offset-md-0 offset-lg-2 pl-lg-0 plt-20'
    },
    // checkLocation() {
    //   return true
    // },
    validateForm() {
      var valid = true
      Object.keys(this.formular).forEach((itemKey) => {
        //console.log(this.formular[itemKey].input_name)
        //console.log(this.formular[itemKey].validation)
        if (this.formular[itemKey].validation) {
          valid = !this.validateItem(itemKey) ? false : valid
        }
      })
      //validate dropdown
      this.selectControl.forEach((element, idx) => {
        if (!element.getFromChoosed) {
          this.selectControl[idx].getFromChoosedError = true
          valid = false
        }
      })
      //
      //Validate checkbox
      if (!this.licenseNeeded && !this.serviceConsulting) {
        this.interestError = true
      } else {
        this.interestError = null
      }
      //
      valid = this.validatePrivacy() ? valid : false
      return valid
    },
    handleFilesUpload() {
      this.files = this.$refs.files[0].files
    },
    resetForm() {
      Object.keys(this.formular).forEach((key) => {
        this.formular[key].model = ''
      })
      this.files = ''
      this.acceptedPrivacyNotification = false
      this.privacyError = null
      setTimeout(() => {
        this.response.message = ''
        this.response.status = null
        this.mailSuccess = 0
      }, 3000)
    },
    sendForm(captchaToken) {
      if (this.validateForm()) {
        let formData = new FormData()
        let endpoint = this.isJobApplication
          ? 'sendApplyMail'
          : 'sendContactMail'
        let responseName = ''
        this.formular.forEach((item) => {
          if (item.model && item.input_name) {
            //console.log('Looping form: ', item.input_name)
            if (item.input_name == 'firstname') {
              responseName = item.model
              //console.log('Firtsname: ', item.input_name, item.model)
              formData.append(item.input_name, item.model)
              //ad checkboxes once
              formData.append('interested_in_licenses', this.licenseNeeded)
              formData.append(
                'interested_in_service_consulting',
                this.serviceConsulting
              )
              formData.append(
                'acceptedPrivacyNotification',
                this.acceptedPrivacyNotification
              )
              //console.log('interested_in_licenses', this.licenseNeeded)
              /* console.log(
                'interested_in_service_consulting',
                this.serviceConsulting
              ) */
              /* console.log(
                'accepted_privacy_notification',
                this.acceptedPrivacyNotification
              ) */
              //end checkboxes
            } else if (item.input_name !== 'files') {
              //console.log('Append not files: ', item.input_name, item.model)
              formData.append(item.input_name, item.model)
            }
          }
        })
        if (this.isJobApplication) {
          for (var i = 0; i < this.files.length; i++) {
            let file = this.files[i]
            formData.append('files[' + i + ']', file)
          }
          formData.append('position', this.position)
        } else if (this.locationProp && this.locationProp !== '') {
          formData.append('location', this.locationProp)
        }
        //add captcha token in form
        formData.append('captchaToken', captchaToken)
        //console.log('FORMDATA')
        this.$store
          .dispatch(endpoint, formData)
          .then(() => {
            this.response.status = status
            this.resetForm()
            this.response.message = this.getEmailSuccessMsg(responseName)
          })
          .catch((err) => {
            console.error(err.response.data)
          })
      }
    },
    async submitForm() {
      if (!this.recaptchaShow) {
        this.recaptchaShow = true
        return
      }
      try {
        const captchaToken = await this.$recaptcha.getResponse()
        if (!captchaToken) {
          console.log('captcha not valid')
          return
        }
        this.sendForm(captchaToken)
      } catch (error) {
        console.log('captcha error', error)
      }
    }
  },
  mounted() {
    if (
      this.locations &&
      this.locations[0] &&
      this.locations[0].location_details
    ) {
      this.alphabeticSort(this.locations[0].location_details)
    }

    //
    //

    //
    let formType = !this.isJobApplication
      ? 'contact_formular'
      : 'job-detail_formular'
    let mode = 'draft'
    if (process.server) {
      const draftArr = [
        'localhost:3000',
        'stage.trakken.de',
        'stage.trakken.at',
        'stage.trakken.ch',
        'stage.trakken.se',
        'stage.trakken.es',
        'stage.trakkenwebservices.com'
      ]
      mode = draftArr.indexOf(req.headers.host) >= 0 ? 'draft' : mode
    }
    this.$storyapi
      .get(`cdn/stories/en/globals/${formType}`, {
        version: mode
      })
      .then((res) => {
        // this.headline = res.data.story.content.text[0].headline[0].text
        // this.subheadline = res.data.story.content.text[0].subheadline[0].text
        this.formular = res.data.story.content.formular.map((item) => {
          item.model = ''
          item.isRequired = item.validation
            ? item.validation.indexOf('required') >= 0
            : null
          item.errors = {}
          if (item.validation) {
            item.validation.forEach((val) => {
              item.errors[val] = false
            })
          }
          if (this.isJobApplication && item.input_name == 'location') {
            item.options = this.locations
            item.model = this.locations[0]
          }
          if (item.input_name == 'salutation') {
            item.options = this.getSalutaions()
            item.model = this.getSalutaions()[1]
          }
          return item
        })
      })
  },
  computed: {
    fileNames() {
      if (this.files != '') {
        let filenames = ''
        Array.from(this.files).forEach((file) => {
          console.log('filename', file.name)
          filenames += file.name + ' '
        })
        return filenames
      }
      return ''
    }
  },
  props: {
    isJobApplication: {
      type: Boolean,
      required: false,
      default: false
    },
    position: {
      type: String,
      required: false,
      default: null
    },
    locationProp: {
      type: String,
      required: false,
      default: null
    },
    locations: {
      type: Array,
      required: false,
      default: () => []
    },
    headline: {
      type: String,
      required: false,
      default: null
    },
    subheadline: {
      type: String,
      required: false,
      default: null
    },
    isTwoCol: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TrakkenSelect,
    TrakkenSubmit,
    PreHead
  }
}
